import constants from '~/constants.js';
import { get, post } from '~/utils/WebRequestUtils';

const END_POINTS = constants.endPoints;

export function login({ login, password }) {
  return post(END_POINTS.login, undefined, { login, password });
}

export function getNumAgents() {
  return get(END_POINTS.agents.count);
}

export function getAgent(id) {
  return get(END_POINTS.agents.get, {
    id: id,
  });
}

export function getAgentsList(params) {
  return get(END_POINTS.agents.list, undefined, params);
}

export function callAgent(id) {
  return post(END_POINTS.agents.call, {
    id: id,
  });
}

export function getReviewList(params) {
  return get(END_POINTS.agents.reviews.get, params);
}

export function submitReview(params) {
  return post(
    END_POINTS.agents.reviews.post,
    {
      id: params.id,
    },
    params.inputs
  );
}

export function getReviewable(params) {
  return get(END_POINTS.agents.reviewable);
}



// WEBPACK FOOTER //
// ./src/lib/api.js